<div class="car-page">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="car-progress-bar" *ngIf="!enregistrementTerminer">
    <div class="car-progress-bar__inner"></div>
  </div>

  <!-- ── Page header ──────────────────────────────── -->
  <header class="car-page__header">
    <h1 class="car-page__title">
      <span class="car-page__title-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      </span>
      Groupes Catégories
    </h1>
    <p class="car-page__subtitle">Gérer les groupes principaux, les menus associés et l'ordonnancement de vos
      catalogues.</p>
  </header>

  <form #f="ngForm">
    <div class="car-grid">

      <!-- ══ LEFT PANEL — Configuration du Groupe ══ -->
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
            </span>
            Configuration du Groupe
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="ajouterGroupe(f)" [disabled]="disabled"
              class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter
            </button>
            <button type="button" (click)="modifierGroupe(f)" class="car-btn car-btn--success car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Modifier
            </button>
            <button type="button" (click)="supprimerGroupeCategorie()" [disabled]="disabledBtnSupprimerGroupe"
              class="car-btn car-btn--danger car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4h6v2" />
              </svg>
              Supprimer
            </button>
          </div>
        </div>

        <div class="car-panel__body">

          <!-- Form row: image + article search + category + ordre -->
          <div class="grp-form-strip">

            <!-- Image upload -->
            <div class="grp-img-upload">
              <div class="grp-img-upload__preview" (click)="importer('input_30_30')">
                <img id="30_30"
                  [src]="lastEvent == 'upload' ? imageCategorieSrc : generalService.base_url + 'images/' + imageCategorieSrc"
                  alt="Preview" />
                <div class="grp-img-upload__overlay">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                    <circle cx="12" cy="13" r="4" />
                  </svg>
                </div>
              </div>
              <input id="input_30_30" type="file" style="display:none" (change)="onChangeImagefile2($event)" />
              <button type="button" (click)="supprimerImage()" [disabled]="disabledBtnSupprimerGroupe"
                class="grp-img-upload__clear">Effacer</button>
            </div>

            <!-- Article search -->
            <!-- <div class="car-field car-field--grow">
              <label class="car-label">Article</label>
              <app-recherche #rechercheComponent recherche="ecarticleauto2" displayColumn="Art_Des" name="article"
                placeholder="Rechercher un article..."></app-recherche>
            </div> -->

            <!-- Category dropdown -->
            <div class="car-field car-field--grow">
              <label class="car-label">Catégorie</label>
              <app-searchable-dropdown #searchableDropDown [items]="categories" [labelKey]="'categorie_Text'"
                [placeholder]="'Catégorie *'"
                (select)="groupe.ecGroup_Label = $event.categorie_Text; onGroupeSelected($event)"
                (inputChange)="groupe.ecGroup_Label = $event">
              </app-searchable-dropdown>
            </div>

            <!-- Ordre -->
            <div class="car-field car-field--ordre">
              <label class="car-label">Ordre</label>
              <input class="car-input" type="number" min="0" name="groupe_Ordre" #groupe_Ordre="ngModel" required
                [(ngModel)]="groupe.ecGroup_Ordre" placeholder="0" />
            </div>

          </div>

          <!-- Search filter -->
          <!-- <div class="car-toolbar">
            <div class="car-search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
                placeholder="Filtrer la table…" />
            </div>
          </div> -->

          <!-- Groupes table — pure HTML, zero Material -->
          <div class="car-table-wrap">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width:64px">Image</th>
                  <th style="width:64px">Code</th>
                  <th>Texte</th>
                  <th style="width:70px">Ordre</th>
                  <th style="width:90px" class="center">Afficher Image</th>
                  <th style="width:90px" class="center">Images Bas</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let element of dataSourceGroupes.data ?? dataSourceGroupes; let i = index"
                  (click)="selectRowGroupe($event, element)" [class.selected]="element === rowGroupe">
                  <td>
                    <div class="grp-thumb">
                      <img *ngIf="element.ecGroup_Code"
                        [src]="generalService.base_url + 'images/' + element.ecGroup_Icone" alt="" />
                    </div>
                  </td>
                  <td class="code">{{ element.ecGroup_Code }}</td>
                  <td class="bold">{{ element.ecGroup_Label | textPipe : 'capitalize' }}</td>
                  <td>{{ element.ecGroup_Ordre }}</td>
                  <td class="center">
                    <label class="car-toggle car-toggle--sm">
                      <input type="checkbox" [name]="'check' + element.ecGroup_Code" [(ngModel)]="checkedStatut[i]"
                        (change)="onselectionChange($event, element)" />
                      <span class="car-toggle__track"></span>
                    </label>
                  </td>
                  <td class="center">
                    <label class="car-toggle car-toggle--sm">
                      <input type="checkbox" [name]="'checkPos' + element.ecGroup_Code" [(ngModel)]="checkedPos[i]"
                        (change)="onselectionChangeCheckBox($event, element)" />
                      <span class="car-toggle__track"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

      <!-- ══ RIGHT PANEL — Menu du Groupe ══ -->
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
              </svg>
            </span>
            Menu du Groupe
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="ajouterMenue(f)" [disabled]="disabled"
              class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter menu
            </button>
          </div>
        </div>

        <div class="car-panel__body">

          <!-- Libellé + Code row -->
          <div class="car-form-row">
            <div class="car-field car-field--grow">
              <label class="car-label">Libellé Menu</label>
              <input class="car-input" name="menue_Label" #menue_Label="ngModel" required
                [(ngModel)]="groupeMenue.ecGroupMenu_Label" placeholder="Texte du menu" />
            </div>
            <div class="car-field car-field--ordre">
              <label class="car-label">Code Cat.</label>
              <input class="car-input" type="number" name="menue_code" #menue_code="ngModel"
                [(ngModel)]="groupeMenue.ecGroupMenu_Id" placeholder="ID" />
            </div>
          </div>

          <!-- Association Articles sub-section -->
          <div class="grp-sub-section">
            <div class="grp-sub-section__title">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                  d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
              </svg>
              Association Articles
            </div>
            <div class="car-field car-field--grow">
              <label class="car-label">Libellé Menu</label>
              <input readonly class="car-input" name="row-menu" [(ngModel)]="rowName" placeholder="menu choisi" />
            </div>
            <div class="car-form-row">

              <div class="car-field car-field--grow">
                <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="articleName"
                  placeholder="Sélectionner l'article…" (ChampEnter)="onArticleSelected($event)"
                  [(ngModel)]="parentVal"></app-recherche>
              </div>
              <div class="car-field car-field--ordre">
                <label class="car-label">Ordre</label>
                <input class="car-input" name="Ordre_Art" #menueTab_Label="ngModel" [(ngModel)]="ordreArticle"
                  placeholder="0" />
              </div>
            </div>

            <div class="car-toolbar car-toolbar--end">
              <button type="button" (click)="ajouterArticle()" class="car-btn car-btn--success car-btn--sm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Lier Article
              </button>
              <button type="button" (click)="modifierArticle()" class="car-btn car-btn--slate car-btn--sm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
                </svg>
                Modifier Ordre
              </button>
              <button type="button" [disabled]="disabledBtnSupprimerArticleMenue" (click)="supprimerArticleMenue()"
                class="car-btn car-btn--danger car-btn--sm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                Supprimer
              </button>
            </div>
          </div>

          <!-- Menu table with expandable rows -->
          <div class="car-table-wrap" *ngIf="showMenu">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width:36px"></th>
                  <th style="width:64px">Code</th>
                  <th>Texte</th>
                  <th style="width:80px">Ordre</th>
                  <th style="width:72px" class="center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let element of dataSourceMenue.data ?? dataSourceMenue; let i = index">
                  <!-- Main row -->
                  <tr [id]="'trTable' + element.ecGroupMenu_Code"
                    (click)="selectRowMenu($event, element, 'trTable' + element.ecGroupMenu_Code)"
                    [class.selected]="element === selectedMenu">
                    <!-- Expand toggle -->
                    <td class="center">
                      <button type="button" class="grp-expand-btn" (click)="toggleRow(element, $event)"
                        [class.expanded]="element.testExpande">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2.5">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </button>
                    </td>
                    <td class="code">{{ element.ecGroupMenu_Code }}</td>
                    <td>
                      <input class="car-input car-input--ghost" [name]="'menueTab_Label' + element.ecGroupMenu_Code"
                        required [(ngModel)]="element.ecGroupMenu_Label" />
                    </td>
                    <td>
                      <input class="car-input car-input--ghost car-input--order" type="number"
                        [name]="'menueTab_Labels' + element.ecGroupMenu_Ordre"
                        [(ngModel)]="element.ecGroupMenu_Ordre" />
                    </td>
                    <td class="center">
                      <div class="grp-row-actions">
                        <button type="button" class="grp-icon-btn grp-icon-btn--amber" title="Modifier"
                          (click)="modifierMenue(element, f)">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                        </button>
                        <button type="button" class="grp-icon-btn grp-icon-btn--rose" title="Supprimer"
                          (click)="supprimerMenueGroupe(element)">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>

                  <!-- Expanded detail row -->
                  <tr *ngIf="element.testExpande" class="grp-detail-row">
                    <td colspan="5" class="grp-detail-cell">
                      <div class="grp-detail-inner">
                        <table class="car-table car-table--nested">
                          <thead>
                            <tr>
                              <th style="width:90px">Code Article</th>
                              <th>Désignation</th>
                              <th style="width:80px">Ordre</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let d of element.detail" [id]="'trTableArticle' + d.Art_Code"
                              (click)="selectRowArticles($event, d, 'trTableArticle' + d.Art_Code)"
                              (dblclick)="onRowDoubleClick( d)">
                              <td class="code">{{ d.Art_Code }}</td>
                              <td class="bold">{{ d.Art_Des }}</td>
                              <td>
                                <input class="car-input car-input--ghost car-input--order" type="number"
                                  [name]="'orderArticle' + d.ecGroup_Ordre + d.Art_Code" [(ngModel)]="d.ecGroup_Ordre"
                                  (focus)="onFocusOrder(d.Id, d.ecGroup_Ordre)"
                                  (blur)="onBlurOrder(d.Id, d.ecGroup_Ordre)" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </div>
  </form>

  <!-- ── Bannières section (BIGDAR only) ──────────── -->
  <div *ngIf="rowGroupe?.ecGroup_Code && generalService.cuurentUser == 'BIGDAR'" class="car-panel grp-banner-panel">

    <div class="car-panel__header grp-banner-header">
      <div class="car-panel__header-left">
        <span class="grp-banner-accent"></span>
        Bannières Catégorie :
        <span class="grp-banner-name">"{{ rowGroupe?.ecGroup_Label }}"</span>
      </div>
      <div class="car-panel__header-actions">
        <button type="button" (click)="importer2('666_450')" [disabled]="buttonDisabled"
          class="car-btn car-btn--outline car-btn--sm" title="Téléverser une image">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="16 16 12 12 8 16" />
            <line x1="12" y1="12" x2="12" y2="21" />
            <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
          </svg>
          Upload
        </button>
        <button type="button" (click)="enregistrerTextImage()" [disabled]="buttonDisabled"
          class="car-btn car-btn--primary car-btn--sm" title="Sauvegarder l'ordre">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
          </svg>
          Sauvegarder
        </button>
        <button type="button" (click)="supprimer()" [disabled]="buttonDisabled"
          class="car-btn car-btn--danger car-btn--sm" title="Supprimer la sélection">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
          </svg>
          Supprimer
        </button>
        <input id="input_666_450" type="file" style="display:none"
          (change)="onChangeImagefile($event, 'ajouterBannier')" />
        <input id="input_modifier_666_450" type="file" style="display:none"
          (change)="onChangeImagefile($event, 'modifierBannier')" />
      </div>
    </div>

    <div class="car-panel__body">
      <div class="grp-banner-grid">
        <div
          *ngFor="let img of listeImages | filterPerAnykey : 'ImmageBannerCat_' + rowGroupe.ecGroup_Code; let i = index"
          class="grp-banner-item" (click)="selectImageDeatail(img.File_Id, i)">
          <img [id]="img.File_Id"
            [src]="(useDataBaseToSaveImage == 1 ? img.File_Content : base_url + 'images/') + img.File_Content"
            alt="Banner" />
          <div class="grp-banner-item__overlay">
            <span>ID: {{ img.File_Id }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>